import React from "react";
import { TrendingUp } from "lucide-react";

const DIMENSION_LABELS = {
  personality: "Personalidade",
  values: "Valores",
  vision: "Sonhos & visão",
  mental_spiritual: "Mental & espiritual",
  physical: "Físico",
  lifestyle: "Estilo de vida",
};

const tierFor = (p) => {
  if (p >= 90) return { label: "Topo 10%", color: "text-[#C5A880]", bg: "bg-[#C5A880]" };
  if (p >= 75) return { label: "Topo 25%", color: "text-[#C5A880]", bg: "bg-[#C5A880]/80" };
  if (p >= 50) return { label: "Acima da média", color: "text-[#DCD7D2]", bg: "bg-[#DCD7D2]/70" };
  if (p >= 25) return { label: "Abaixo da média", color: "text-[#A29F9B]", bg: "bg-[#A29F9B]/60" };
  return { label: "Pouco alinhado", color: "text-[#7A2021]", bg: "bg-[#7A2021]/70" };
};

const PercentileBar = ({ label, value }) => {
  const tier = tierFor(value);
  return (
    <div className="flex items-center gap-4" data-testid={`percentile-${label}`}>
      <div className="w-36 text-sm text-[#DCD7D2]">{label}</div>
      <div className="flex-1 h-2 rounded-full bg-white/5 overflow-hidden relative">
        <div className={`h-full rounded-full transition-all duration-700 ${tier.bg}`} style={{ width: `${value}%` }} />
      </div>
      <div className="w-28 text-right">
        <span className="font-display text-xl text-[#F5F2EE]">{value}<span className="text-xs text-[#A29F9B]">º</span></span>
        <span className="block text-[10px] uppercase tracking-widest text-[#A29F9B]">percentil</span>
      </div>
    </div>
  );
};

const DimensionalRanking = ({ percentiles, poolSize }) => {
  if (!percentiles) return null;
  const overall = percentiles.overall ?? 0;
  const tier = tierFor(overall);

  return (
    <div className="bg-[#161920] border border-white/5 rounded-2xl p-8 md:p-12" data-testid="ranking-section">
      <div className="flex items-start justify-between mb-8 flex-wrap gap-4">
        <div>
          <span className="label-uppercase">Ranking dimensional</span>
          <h2 className="font-display text-2xl md:text-3xl mt-2">
            Onde este match se posiciona no teu universo
          </h2>
          <p className="text-sm text-[#A29F9B] mt-2">
            Comparado com {poolSize} {poolSize === 1 ? "candidato compatível" : "candidatos compatíveis"} para ti.
          </p>
        </div>
        <div className="text-right">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#C5A880]/10 border border-[#C5A880]/30">
            <TrendingUp className="w-4 h-4 text-[#C5A880]" />
            <span className={`text-xs uppercase tracking-widest font-bold ${tier.color}`}>{tier.label}</span>
          </div>
          <p className="font-display text-4xl mt-2 text-[#C5A880]" data-testid="percentile-overall">
            {overall}<span className="text-sm">º</span>
          </p>
          <p className="text-[10px] uppercase tracking-widest text-[#A29F9B]">percentil global</p>
        </div>
      </div>

      <div className="space-y-4">
        {Object.entries(DIMENSION_LABELS).map(([key, label]) => (
          <PercentileBar key={key} label={label} value={percentiles[key] ?? 0} />
        ))}
      </div>

      <p className="text-xs text-[#A29F9B] mt-8 italic">
        Os percentis indicam quão fora do comum esta ligação é, dimensão a dimensão. Um 92º percentil em "Sonhos & visão"
        significa que apenas ~8% dos teus candidatos compatíveis partilham esta convergência de futuro contigo.
      </p>
    </div>
  );
};

export default DimensionalRanking;
